<template>
  <div class="Japan-visa">
    <Head style="background-color: #cbb486" />
    <div class="content">
      <div class="background-index">
        <div class="top-title common">出国签证</div>
        <div class="middle-title common">Special service information</div>
        <div class="bottom-operator common">
          <BreadCrumbs />
        </div>
        <div class="common content-operator cgqz">
          <div class="visa">
            <a-tabs
              default-active-key="1"
              :activeKey="activeKey"
              @change="change"
            >
              <a-tab-pane
                key="1"
                tab="签证办理预约"
                :tabBarStyle="tabBarStyle"
                class="visa-handle-reserve"
              >
                <div class="info-collect">
                  <a-steps :current="reserveStep">
                    <a-step title="填写预约信息" />
                    <a-step title="选择预约时间" />
                    <a-step title="个人信息填写" />
                    <a-step title="打印预约回执" />
                  </a-steps>
                  <div class="step-content">
                    <div class="step-content-one" v-if="reserveStep === 0">
                      <div class="write-reserve-info-title">
                        <p>填写预约信息</p>
                        <p>(以下必填项，如无身份证，请直接拨打87810788)</p>
                      </div>
                      <div class="write-reserve-info-form">
                        <a-form
                          :form="form"
                          :label-col="{ span: 5 }"
                          :wrapper-col="{ span: 12 }"
                          @submit="handleSubmit"
                        >
                          <a-row>
                            <a-col :span="12">
                              <a-form-item
                                label="签证类别"
                                :label-col="{ span: 6 }"
                                :wrapper-col="{ span: 16 }"
                              >
                                <a-select
                                  v-decorator="[
                                    'type',
                                    {
                                      initialValue: 'visit',
                                      rules: [{ required: true }],
                                    },
                                  ]"
                                  @change="handleSelectChange"
                                >
                                  <a-select-option value="visit">
                                    探亲
                                  </a-select-option>
                                  <a-select-option value="trip">
                                    拘留
                                  </a-select-option>
                                  <a-select-option value="trip2">
                                    商务
                                  </a-select-option>
                                </a-select>
                              </a-form-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-item
                                label="探亲类别"
                                :label-col="{ span: 6 }"
                                :wrapper-col="{ span: 16 }"
                              >
                                <a-select
                                  v-decorator="[
                                    'type',
                                    {
                                      initialValue: 'visit',
                                      rules: [{ required: true }],
                                    },
                                  ]"
                                  @change="handleSelectChange"
                                >
                                  <a-select-option value="visit">
                                    探亲
                                  </a-select-option>
                                  <a-select-option value="trip">
                                    访友
                                  </a-select-option>
                                  <a-select-option value="trip1">
                                    同伴入国单次
                                  </a-select-option>
                                  <a-select-option value="trip2">
                                    同伴入国一年多次
                                  </a-select-option>
                                  <a-select-option value="trip3">
                                    同伴入国三年多次
                                  </a-select-option>
                                  <a-select-option value="trip4">
                                    过境
                                  </a-select-option>
                                  <a-select-option value="trip5">
                                    再入国许可延期
                                  </a-select-option>
                                  <a-select-option value="trip6">
                                    再入国确认
                                  </a-select-option>
                                </a-select>
                              </a-form-item>
                            </a-col>
                          </a-row>
                          <a-row>
                            <a-col :span="12">
                              <a-form-item
                                label="姓名"
                                :label-col="{ span: 6 }"
                                :wrapper-col="{ span: 16 }"
                              >
                                <a-input
                                  v-decorator="[
                                    'name',
                                    { rules: [{ required: true }] },
                                  ]"
                                />
                              </a-form-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-item
                                label="身份证号码"
                                :label-col="{ span: 6 }"
                                :wrapper-col="{ span: 16 }"
                              >
                                <a-input
                                  placeholder="如没有身份证,请拨打87810788联系我处"
                                  v-decorator="[
                                    'identificationNumber',
                                    { rules: [{ required: true }] },
                                  ]"
                                />
                              </a-form-item>
                            </a-col>
                          </a-row>
                          <a-row>
                            <a-col :span="12">
                              <a-form-item
                                label="联系手机号码"
                                :label-col="{ span: 6 }"
                                :wrapper-col="{ span: 16 }"
                              >
                                <a-input
                                  placeholder="如没有收集请填无"
                                  v-decorator="[
                                    'phoneNumber',
                                    { rules: [{ required: true }] },
                                  ]"
                                />
                              </a-form-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-item
                                label="护照号"
                                :label-col="{ span: 6 }"
                                :wrapper-col="{ span: 16 }"
                              >
                                <a-input
                                  v-decorator="[
                                    'passportNumber',
                                    { rules: [{ required: true }] },
                                  ]"
                                />
                              </a-form-item>
                            </a-col>
                          </a-row>
                        </a-form>
                        <a-row class="form-submit">
                          <a-col>
                            <a-button type="primary" @click="handleSubmit">
                              选择预约时间
                            </a-button>
                          </a-col>
                        </a-row>
                      </div>
                    </div>
                    <div class="step-content-two" v-if="reserveStep === 1">
                      <a-row>
                        <a-col :span="12">
                          <a-form-item
                            label="预约日期"
                            :label-col="{ span: 6 }"
                            :wrapper-col="{ span: 16 }"
                          >
                            <a-date-picker
                              placeholder="请选择预约日期"
                              style="width: 100%"
                            />
                          </a-form-item>
                        </a-col>
                        <a-col :span="12">
                          <a-form-item
                            label="预约时段"
                            :label-col="{ span: 6 }"
                            :wrapper-col="{ span: 16 }"
                          >
                            <a-date-picker
                              placeholder="请选择预约时段"
                              style="width: 100%"
                            />
                          </a-form-item>
                        </a-col>
                      </a-row>
                      <a-row class="form-submit">
                        <a-col>
                          <a-button type="primary" @click="reserveStep = 2">
                            确定预约时间
                          </a-button>
                        </a-col>
                      </a-row>
                    </div>
                    <div class="step-content-three" v-if="reserveStep === 2">
                      3
                    </div>
                    <div class="step-content-four" v-if="reserveStep === 3">
                      4
                    </div>
                  </div>
                  <div class="reserve-info">
                    <div class="reserve-info-tab">
                      <span
                        :class="{ choose: reserveInfo === 1 }"
                        @click="turnToOne"
                        >预约通知</span
                      ><span
                        :class="{ choose: reserveInfo === 2 }"
                        @click="turnToTwo"
                        >注意事项</span
                      >
                    </div>
                    <div class="reserve-info-content" v-if="reserveInfo === 1">
                      <h3>关于启用日本签证受理网上预约系统的通知</h3>
                      <p>
                        为保证赴日签证受理工作的正常有序进行，我中心已启用赴日签证受理网上预约系统。前来办理探亲、商务、居留签证的申请人请提前登录我中心网站www.ffasc.cn“日本签证网上预约”系统，预约签证办理时间，填写所需表格。
                        <br />
                        持有《在留资格认定证明书》的签证申请人请事先下载打印问答卷(<a
                          >https://www.guangzhou.cn.emb-japan.go.jp/cgip_cn/visa/doc/vi-
                          sa0005.htm</a
                        >)，认真填写表格中每个栏目信息后再进行预约，未填写完整者不能按预约时间受理。在疫情防控期间，按有关文件要求，请申请人事先下载“闽政通”APP，生成“八闽健康码”（具体操作方法请点击以下链接查看:
                        <a
                          >https://www.ffasc.cn/templates/tem-plate2/2/202003_15_5285.html</a
                        >) 。
                        <br />
                        请已预约的申请人凭当日预约单和“八闽健康码”按照预约时段进入日本签证受理大厅办理签证。
                      </p>
                    </div>
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="材料预审">
                <div class="icon-tabd">
                  <img
                    src="../../../assets/images/icon_construction.png"
                    alt=""
                  />
                  <div class="icon-tabdd">抱歉！我们正在努力建设中~~</div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="3" tab="办理进度查询">
                <a-row style="margin-top: 25px">
                  <a-col :span="12">
                    <a-form-item
                      label="预约号"
                      :label-col="{ span: 6 }"
                      :wrapper-col="{ span: 16 }"
                    >
                      <a-input
                        placeholder=""
                        v-decorator="[
                          'phoneNumber',
                          { rules: [{ required: true }] },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      label="身份证号"
                      :label-col="{ span: 6 }"
                      :wrapper-col="{ span: 16 }"
                    >
                      <a-input
                        v-decorator="[
                          'passportNumber',
                          { rules: [{ required: true }] },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row class="form-submit">
                  <a-col>
                    <a-button type="primary" @click="null"> 查询 </a-button>
                  </a-col>
                </a-row>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
    </div>

    <Footer class="footer" />
  </div>
</template>

<script>
import BreadCrumbs from "@/components/home/breadCrumbs";
import Head from "@/components/index/head";
import Footer from "@/components/index/footer";

export default {
  name: "index",
  components: { BreadCrumbs, Footer, Head },
  data() {
    return {
      reserveStep: 0,
      tabBarStyle: {},
      formLayout: "inline",
      form: this.$form.createForm(this, { name: "coordinated" }),
      reserveInfo: 1,
      activeKey: "1",
    };
  },
  created() {
    this.change(this.$route.query.key || "1");
    window.scrollTo(0, 0);
  },
  methods: {
    change(e) {
      this.activeKey = e;
    },
    turnToOne() {
      this.reserveInfo = 1;
    },
    turnToTwo() {
      this.reserveInfo = 2;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
      this.reserveStep = 1;
    },
    handleSelectChange(value) {},
  },
};
</script>

<style scoped lang='less'>
/deep/ .ant-select-selection:hover {
  border-color: #decba4;
  border-right-width: 1px !important;
}
/deep/ .ant-select-selection:active {
  border-color: #decba4;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: none;
}
/deep/ .ant-input:hover {
  border-color: #decba4;
  border-right-width: 1px !important;
}
/deep/ .ant-input:focus {
  border-color: #decba4;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: none;
}
.visa[data-v-06a306d8] .ant-tabs-tabpane  {
  border: none;
}
.icon-tabd {
  // border:none;
  width: 100%;
  height: 250px;
}
.icon-tabdd {
  font-family: MicrosoftYaHei;
  font-weight: Regular;
  margin-top: 20px;
  color: #aaaaaa;
}
.footer.content {
  height: 302px;
}
.content {
  width: 1366px;
  height: 1400px;
  margin-bottom: 30px;
}
.background-index {
  height: 280px !important;
  width: 100%;
  position: absolute;
  index: -1;
  background-image: url("../../../assets/images/icon_window_service_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.top-title {
  width: 100%;
  height: 65px;
  font-size: 50px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
  top: 110px;
}
.middle-title {
  width: 736px;
  height: 31px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  top: 180px;
}
.common {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.bottom-operator {
  width: 100%;
  height: 182px;
  top: 280px;
  left: 0;
  transform: translateX(0);
  background: white;
}
.content-operator {
  top: 382px;
  background: white;
  height: 1000px;
  width: 1140px;
}
.more {
  color: #cdad7f;
  font-size: 16px;
  cursor: pointer;
}

.visa /deep/ .ant-tabs-tab {
  color: #c4c5c7;
  font-size: 24px;
  font-weight: bold;
}
.visa /deep/ .ant-tabs-tab-active {
  color: black;
  margin-bottom: 6px;
}
.visa /deep/ .ant-tabs-ink-bar {
  background-color: #cbb483;
  height: 2.5px;
  position: relative;
  z-index: 1;
  top: -10px;
}
.visa /deep/ .ant-tabs-tab-active:before {
  width: 0;
  height: 0;
  display: block;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid transparent;
  border-bottom: 6px solid #cbb387;
  position: relative;
  top: 56px;
  left: 46%;
  transform: rotate(180deg);
  z-index: 2;
}
.visa /deep/ .ant-tabs-tabpane {
  transform: translateX(-50%);
  position: relative;
  left: 50%;
  border: #e9e9e9 solid 1px;
}
.visa /deep/ .ant-tabs-bar {
  border-bottom: 0;
}
.info-collect {
  padding: 30px;
}
.info-collect /deep/ .ant-steps-item-container {
  text-align: left;
}
.info-collect /deep/ .ant-steps {
  width: 70%;
  margin: 0 15%;
  display: flex;
  justify-content: center;
}
/deep/ .ant-steps-item-container .ant-steps-item-title:after {
  height: 2px;
}
.step-content {
  margin: 30px 0;
}
.write-reserve-info-title {
  text-align: left;
}
.write-reserve-info-title p {
  display: inline-block;
  color: #c4c4c4;
}
.write-reserve-info-title p:first-child {
  color: black;
  font-size: 20px;
  font-weight: bold;
  margin-right: 25px;
}
.write-reserve-info-form form {
  padding: 24px 0;
  background-color: #f7f7f7;
  border: 1px solid #e9e9e9;
}
.form-submit {
  margin: 24px auto;
}
.form-submit /deep/ .ant-btn-primary {
  /* width: 100px; */
  height: 46px;
  background: #aa1729;
  color: white;
  border-color: white !important;
  text-align: center;
}
.form-submit /deep/ .ant-btn-primary:hover {
  border-color: white !important;
}
/*.step-content /deep/ .ant-form-item {*/
/*  width: 48%;*/
/*  display: inline-block;*/
/*}*/
/deep/ .ant-steps-item-active .ant-steps-item-container .ant-steps-item-icon {
  background-color: #cab485;
  color: white;
  border: 0;
}
/deep/ .ant-steps-item-active .ant-steps-item-container .ant-steps-item-title {
  color: #cab187;
}
/deep/
  .ant-steps-item-active
  .ant-steps-item-container
  .ant-steps-item-title:after {
  background-color: #ccb488;
}

.reserve-info-tab {
  text-align: left;
  color: #bdbfc0;
  font-size: 20px;
  margin-bottom: 24px;
}
.reserve-info-tab span.choose {
  color: black;
  border-bottom: 1px solid #cebd97;
}
.reserve-info-tab span {
  display: inline-block;
  padding: 10px 0;
  font-weight: bold;
  cursor: pointer;
}
.reserve-info-tab span:first-child {
  margin-right: 25px;
}

.reserve-info-content h3 {
  font-weight: bold;
  line-height: 50px;
  text-align: left;
}
.reserve-info-content p {
  text-align: left;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/content/JapanVisa/index.vue